import Container from '@/components/Container';
import { Enum_Favorite_Type } from '@/graphql/generated/graphql';
import Cards from './components/card';
import MoreButton from './components/more-button';
import { useFavoriteStore } from './store/useFavoriteStore';
import { useEffect } from 'react';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export default function FavouritePage() {
  const {
    podcasts,
    resources,
    courses,
    showPodcastsMoreButton,
    showResourcesMoreButton,
    showCoursesMoreButton,
    page,
    handleMore,
    onInit,
  } = useFavoriteStore();

  useEffect(() => {
    onInit();
  }, [onInit]);

  return (
    <Container className="pb-sh-60" addMargin>
      <div className="col-span-12  min-h-[30rem] md:col-start-3 md:col-end-11">
        <section>
          <AnimatedFadeInComponent>
            <h1 className="font-larken text-sh-lg">{page?.yourFavouriteTitle}</h1>
          </AnimatedFadeInComponent>
        </section>

        <section>
          <AnimatedFadeInComponent>
            <h1 className="my-sh-30 font-larken text-sh-md">{page?.podcastTitle}</h1>
          </AnimatedFadeInComponent>
          <Cards entities={podcasts} type={Enum_Favorite_Type.Podcast} />
          <AnimatedFadeInComponent>
            {podcasts.length === 0 && <p className="text-start text-sh-sm">{page?.noPodcastsFoundMsg}</p>}
            {showPodcastsMoreButton && <MoreButton setSize={() => handleMore(Enum_Favorite_Type.Podcast)} />}
          </AnimatedFadeInComponent>
        </section>

        <section>
          <AnimatedFadeInComponent>
            <h1 className="my-sh-30 font-larken text-sh-md">{page?.resourcesTitle}</h1>
          </AnimatedFadeInComponent>
          <Cards entities={resources} type={Enum_Favorite_Type.Resource} />
          <AnimatedFadeInComponent>
            {resources.length === 0 && <p className="text-start text-sh-sm">{page?.noResourcesFoundMsg}</p>}
            {showResourcesMoreButton && <MoreButton setSize={() => handleMore(Enum_Favorite_Type.Resource)} />}
          </AnimatedFadeInComponent>
        </section>

        <section>
          <AnimatedFadeInComponent>
            <h1 className="my-sh-30 font-larken text-sh-md">{page?.courseTitle}</h1>
          </AnimatedFadeInComponent>
          <Cards entities={courses} type={Enum_Favorite_Type.Learn} />
          <AnimatedFadeInComponent>
            {courses.length === 0 && <p className="text-start text-sh-sm">{page?.noCoursesFoundMsg}</p>}
            {showCoursesMoreButton && <MoreButton setSize={() => handleMore(Enum_Favorite_Type.Learn)} />}
          </AnimatedFadeInComponent>
        </section>
      </div>
    </Container>
  );
}
